/*!
 * Copyright (c) REWE Digital GmbH
 */
import { Host, h } from "@stencil/core";
/**
 VxPaginator component.
 */
export class VxPaginator {
    constructor() {
        /**
         * Emit navigation event from paginator to a selected page.
         *
         * @param {number} page - The page to navigate to.
         */
        this.selectPage = (page) => this.pageSelected.emit({ page });
        /**
         * Navigate to previous page.
         */
        this.previousPage = (_event, { pagination, selectPage } = this) => {
            if (pagination.page > 1) {
                selectPage(pagination.page - 1);
            }
        };
        /**
         * Navigate to next page.
         */
        this.nextPage = (_event, { pagination, selectPage } = this) => {
            if (pagination.page < pagination.pageCount) {
                selectPage(pagination.page + 1);
            }
        };
        this.previousButton = 'Zurück';
        this.nextButton = 'Weiter';
        this.pageName = 'Page';
        this.pagination = undefined;
    }
    /**
     * Build option list for the page select dropdown.
     */
    buildOptions() {
        const options = [];
        for (let i = 1; i <= this.pagination.pageCount; i++) {
            options.push(h("option", { "aria-label": this.pageName + i, value: i, selected: i === this.pagination.page }, i));
        }
        return options;
    }
    /**
     * Navigate to a selected page.
     *
     * @param {Event} event - The select onChange event.
     */
    onChangeSelectPage(event) {
        const target = event.target;
        if (target) {
            this.selectPage(parseInt(target.options[target.selectedIndex].value, 10));
        }
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} The rendered component.
     */
    render() {
        var _a;
        return (h(Host, { key: '5318785ba45fd267d354a2b163b7f662d6c7ea92' }, ((_a = this.pagination) === null || _a === void 0 ? void 0 : _a.pageCount) > 1 &&
            h("div", { class: "vx-paginator__wrapper" }, h("button", { class: "vx-paginator__btn-left", part: this.pagination.page === 1 ? 'btn-left-disabled' : 'btn-left', disabled: this.pagination.page === 1, onClick: this.previousPage }, this.previousButton), h("select", { class: "vx-paginator__dropdown", onChange: this.onChangeSelectPage.bind(this) }, this.buildOptions()), h("button", { class: "vx-paginator__btn-right", part: this.pagination.page === this.pagination.pageCount ? 'btn-right-disabled' : 'btn-right', disabled: this.pagination.page === this.pagination.pageCount, onClick: this.nextPage }, this.nextButton))));
    }
    static get is() { return "vx-paginator"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-paginator.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-paginator.css"]
        };
    }
    static get properties() {
        return {
            "previousButton": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The button text for the previous button."
                },
                "attribute": "previous-button",
                "reflect": false,
                "defaultValue": "'Zur\u00FCck'"
            },
            "nextButton": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The button text for the next button."
                },
                "attribute": "next-button",
                "reflect": false,
                "defaultValue": "'Weiter'"
            },
            "pageName": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The name of the aria label."
                },
                "attribute": "page-name",
                "reflect": false,
                "defaultValue": "'Page'"
            },
            "pagination": {
                "type": "unknown",
                "mutable": true,
                "complexType": {
                    "original": "{\n        page?: number\n        pageCount?: number\n    }",
                    "resolved": "{ page?: number; pageCount?: number; }",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The pagination object."
                }
            }
        };
    }
    static get events() {
        return [{
                "method": "pageSelected",
                "name": "pageSelected",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "The event emitter for the paginator (prev, next and select page)."
                },
                "complexType": {
                    "original": "{ page: number }",
                    "resolved": "{ page: number; }",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=vx-paginator.js.map
